import { Injectable } from '@angular/core';
import { ParameterTypeEnum } from '../enums/parameterType.enum';
import { FlowrateUnit, GasUnit, PmUnit, RainfallUnit, TemperatureUnit, VolumeUnit, WindspeedUnit } from '../enums/unitPreferences.enum';
import { UserPreferences } from '../models/userPreferences.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ParameterUnitService {
  constructor(protected authService: AuthService) { }

  get preferences(): UserPreferences {
    const currentUser = this.authService.getCurrentUser();
    return currentUser.preferences;
  }

  getParameterUnit(parameterType: ParameterTypeEnum) {
    switch (parameterType) {
      case ParameterTypeEnum.Pm1:
      case ParameterTypeEnum.Pm2_5:
      case ParameterTypeEnum.Pm10:
      case ParameterTypeEnum.RespirablePm:
      case ParameterTypeEnum.BinMass:
      case ParameterTypeEnum.Count0_3:
      case ParameterTypeEnum.Count0_5:
      case ParameterTypeEnum.Count1_0:
      case ParameterTypeEnum.Count2_5:
      case ParameterTypeEnum.Count5_0:
      case ParameterTypeEnum.Count10:
      case ParameterTypeEnum.MeasuredRCS:
        return this.getPmUnit();
      case ParameterTypeEnum.FlowRate:
        return this.getFlowRateUnit();
      case ParameterTypeEnum.Temperature:
      case ParameterTypeEnum.DewPoint:
      case ParameterTypeEnum.FeelsLike:
        return this.getTemperatureUnit();
      case ParameterTypeEnum.Humidity:
      case ParameterTypeEnum.BatteryPercentage:
      case ParameterTypeEnum.SignalStrength:
        return '%';
      case ParameterTypeEnum.Lavg:
        return 'db';
      case ParameterTypeEnum.Ozone:
      case ParameterTypeEnum.SO2:
      case ParameterTypeEnum.NO2:
      case ParameterTypeEnum.CO:
      case ParameterTypeEnum.TVOC:
      case ParameterTypeEnum.CO2:
      case ParameterTypeEnum.H2S:
      case ParameterTypeEnum.NO:
        return this.getGasUnit();
      case ParameterTypeEnum.WindDirection:
        return 'deg';
      case ParameterTypeEnum.WindSpeed:
        return this.getWindspeedUnit();
      case ParameterTypeEnum.ChargingCurrent:
      case ParameterTypeEnum.SystemCurrent:
        return 'A';
      case ParameterTypeEnum.BatteryVoltage:
      case ParameterTypeEnum.ChargingVoltage:
        return 'V';
      case ParameterTypeEnum.Rainfall:
        return this.getRainfallUnit();
      case ParameterTypeEnum.PowerState:
      case ParameterTypeEnum.BatteryCharging:
      case ParameterTypeEnum.Orientation:
      case ParameterTypeEnum.Pressure:
        return '';
    }
  }

  getPmUnit() {
    return PmUnit[this.preferences.pmUnitId];
  }

  getTemperatureUnit() {
    return TemperatureUnit[this.preferences.temperatureUnitId];
  }

  getGasUnit() {
    return GasUnit[this.preferences.gasUnit];
  }

  getWindspeedUnit() {
    return WindspeedUnit[this.preferences.windSpeedUnit];
  }

  getRainfallUnit() {
    return RainfallUnit[this.preferences.rainfallUnit];
  }

  getFlowRateUnit() {
    return FlowrateUnit[this.preferences.flowRateUnit];
  }

  getVolumeUnit() {
    return VolumeUnit[this.preferences.flowRateUnit];/* Preference same as flowRate */
  }
}
